let Language = {
  PORTUGUESE: { id: 1, name: 'Português', symbol: "Pt", lang: 'pt' },
  ENGLISH: { id: 2, name: 'English', symbol: "En", lang: 'en' },
  SPANISH: { id: 3, name: 'Español', symbol: "Sp", lang: 'es' },
};

export default Language;
export const languages = Object.keys(Language).map(key => Language[key]);



// WEBPACK FOOTER //
// ./src/enums/Language.js